const init = () => {
  const mq = window.matchMedia('(min-width: 782px)');
  let breakpoint = '';

  if (mq.matches) {
    breakpoint = 'desktop';
  } else {
    breakpoint = 'mobile';
  }

  return breakpoint;
};

export default init;
